import { NavLink } from 'react-router';
import { t } from '../i18n';

/**
 * The settings pages: how calls work, the carriers and numbers, how the
 * company looks, and its SmartOn. Region managers see only the numbers (read-only).
 */
export function SettingsTabs({ admin = true }: { admin?: boolean }) {
  if (!admin) return null;
  return (
    <nav className="section-tabs" aria-label={t('Settings')}>
      <NavLink to="/settings" end>
        {t('General')}
      </NavLink>
      <NavLink to="/settings/carriers">{t('Carriers')}</NavLink>
      <NavLink to="/settings/numbers">{t('Numbers')}</NavLink>
      <NavLink to="/settings/branding">{t('Branding')}</NavLink>
      <NavLink to="/settings/smarton">SmartOn</NavLink>
    </nav>
  );
}
